import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { InnogyComponentRendering } from '@core/jss-models';
import { NavigationExtras } from '@angular/router';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { GenericLinkDirective } from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackLinkDirective } from '@analytics/events';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-change-button',
  templateUrl: './change-button.component.html',
  styleUrls: [
    './change-button.component.ed.scss',
    './change-button.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CSCaptureDirective,
    GenericLinkDirective,
    AutomationIdDirective,
    TrackLinkDirective,
    FaIconComponent,
  ],
})
export class ChangeButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() link?: LinkField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() extras?: NavigationExtras;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() button?: string;
  @Output()
  clickChange = new EventEmitter();
}
